import { getParser } from 'bowser';
import isBot from 'isbot';

export const MS_OFFICE_CHECKUP = 'office';

const isMSOffice = ua => (ua ? ua.indexOf(MS_OFFICE_CHECKUP) > -1 : true);

const BROWSER_SATISFACTION = {
  Chrome: '>=52',
  Firefox: '>=50',
  'Internet Explorer': '>=11',
  Safari: '>=5',
};

export const browserIsSupported = useragent => {
  const browser = getParser(useragent);
  const isSupported = browser.satisfies(BROWSER_SATISFACTION);
  if (typeof isSupported === 'undefined') {
    console.log('[BC] is unknown ');
    console.log(browser);
    return true;
  } else if (isSupported) {
    console.log('[BC] is supported');
    return true;
  } else {
    console.log('[BC] not supported');
    console.log(browser);
    return false;
  }
};

const NOT_SUPPORTED_URLS = {
  hackschnitzel: `/not-supported`,
  holzbriketts: `/not-supported`,
  pellets: `/not-supported`,
  depi: `/not-supported`,
  depv: `/not-supported`,
};

const isNotSupportedPath = path => {
  return Object.keys(NOT_SUPPORTED_URLS)
    .reduce((acc, key) => {
      return [NOT_SUPPORTED_URLS[key], ...acc];
    }, [])
    .includes(path);
};

export const handleRedirectToNotSupportedPage = (req, res, context) => {
  if (isNotSupportedPath(req.path)) return;
  const useragent = req.headers['user-agent'];
  console.log('[BC] checking user agent');
  console.log('[BC]', useragent);
  // before we check for real browser support we need to let user-agents pass
  // that come from (ms-)office, because when windows user open a page from an
  // office program the headers user-agent is not the default browser but
  // something with (ms-)office
  if (isMSOffice(useragent)) {
    console.log('[BC] isMSOffice');
    return;
  }
  // if the useragent is a crawler/bot let him through
  if (isBot(useragent)) {
    console.log('[BC] isBot');
    return;
  }
  // check for all supported browsers; if one doesnt match
  // we redirect to the redirectPath;
  if (browserIsSupported(useragent)) {
    return;
  }
  res.writeHead(302, {
    Location: NOT_SUPPORTED_URLS[context],
  });
  res.end();
  return;
};
